var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('hight-light',{attrs:{"is-bg":true,"text":"关于我们","bg-text":"About Us"}}),_vm._l((_vm.introduces),function(item){return _c('introduce',{key:item.title,attrs:{"is-left":item.isLeft,"text":item.text,"title":item.title,"img":item.img,"is-white":item.isWhite}})})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }